import { Avatar, Box, Tooltip, useTheme } from '@mui/material';
import { IconShieldLock } from '@tabler/icons-react';
import { ThemeMode } from 'config';
import React from 'react';
import { useNavigate } from 'react-router';
import { useSelector } from 'store';

// Launcher icon for the Ops console. Rendered only for our (admin) company.
const OpsConsoleSection: React.FC = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const companyId = useSelector((state) => state.user?.CompanyId);
  const isAdmin = companyId === import.meta.env.VITE_APP_FUNNER_COMPANY_ID;

  if (!isAdmin) return null;

  return (
    <Box sx={{ ml: 2 }}>
      <Tooltip title="Ops Console">
        <Avatar
          variant="rounded"
          sx={{
            ...theme.typography.commonAvatar,
            ...theme.typography.mediumAvatar,
            border: '1px solid',
            borderColor: theme.palette.mode === ThemeMode.DARK ? 'dark.main' : 'primary.light',
            bgcolor: theme.palette.mode === ThemeMode.DARK ? 'dark.main' : 'primary.light',
            color: 'primary.dark',
            transition: 'all .2s ease-in-out',
            '&[aria-controls="menu-list-grow"],&:hover': {
              borderColor: 'primary.main',
              bgcolor: 'primary.main',
              color: 'primary.light',
            },
          }}
          aria-haspopup="true"
          onClick={() => navigate('/ops-console')}
          color="inherit"
        >
          <IconShieldLock />
        </Avatar>
      </Tooltip>
    </Box>
  );
};

export default OpsConsoleSection;
